/**
 * @expFlag auth-mobile-redirect-app-main-actions
 * @ticket CLOUDWEB-20237
 * @file
 */
import { IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import type { EButtonLocation } from 'reactApp/appHelpers/toolbarActions/constants';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

import type { ERedirectPromoElement } from './redirectToApp.constants';
import type { RedirectAppMainActions } from './redirectToApp.types';

export type RedirectToAppAnalytics = {
    buttonLocation: EButtonLocation | null;
    actionButton: RedirectAppMainActions;
    eventCategory: ECategoryGa.modalActionBlock | ECategoryGa.snackActionBlock;
    action: 'show' | 'close' | 'click_install';
    trkLink?: string;
    sourceFrom: 'folder' | 'grid' | 'viewer';
    productNavigationPlace: 'gallery' | 'files';
};

export const sendRedirectToAppAnalytics = ({
    buttonLocation,
    eventCategory,
    action,
    trkLink,
    actionButton,
    sourceFrom,
    productNavigationPlace,
}: RedirectToAppAnalytics) => {
    const isPhone = EnvironmentSelectors.isPhone();

    sendDwh({
        eventCategory,
        action,
        dwhData: {
            button_location: buttonLocation,
            platform: isPhone ? 'touch' : 'web',
            trk_link: trkLink,
            action_button: actionButton,
            source_from: sourceFrom,
            product_navigation_place: productNavigationPlace,
            enter_source: 'direct',
        },
    });
};

/**
 * @expFlag promo-in-webview-public
 * @ticket CLOUDWEB-20374
 * @start
 */
export type RedirectPromoElementAnalytics = {
    trkLink: string;
    promoElement: ERedirectPromoElement;
    action: 'click' | 'close' | 'show';
};

export const sendRedirectPromoElementAnalytics = ({ trkLink, promoElement, action }: RedirectPromoElementAnalytics) => {
    const isPhone = EnvironmentSelectors.isPhone();

    sendDwh({
        eventCategory: ECategoryGa.redirectPromoElement,
        action,
        dwhData: {
            promo_element: promoElement,
            trk_link: trkLink,
            webview: IS_WEBVIEW,
            platform: isPhone ? 'touch' : 'web',
            enter_source: 'direct',
        },
    });
};

/**
 * @expFlag promo-in-webview-public
 * @ticket CLOUDWEB-20374
 * @end
 */
